import { updateCartlineShippingDate } from "@iewcasia/Services/CustomCartLinesUpdateShippingDateService";
import { splitOrder } from "@iewcasia/Services/CustomCartValidationService";
import { setGA4Event } from "@iewcasia/Store/Handlers/Utilities/CustomTracking";
import { CustomState } from "@iewcasia/Store/Reducers";
import formatDateWithTimezone from "@insite/client-framework/Common/Utilities/formatDateWithTimezone";
import { addToChainAfter, addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    ExecuteOnSuccessCallback,
    PopulateApiParameter,
    UpdateCart,
    chain,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";

const convertDateToApiFormat = (date: Date | null) => (date ? formatDateWithTimezone(date) : "");

addToChainAfter(chain, ExecuteOnSuccessCallback, props => {
    // set GA4 event for purchase
    setGA4Event(props.cartToUpdate, "purchase");
});

replaceInChain(chain, PopulateApiParameter, props => {
    if (!props.cartToUpdate) {
        return;
    }

    const {
        pages: {
            checkoutReviewAndSubmit: { requestedDeliveryDate, requestedPickupDate },
        },
        customReviewAndSubmit,
    } = props.getState() as CustomState;

    if (props.cartToUpdate.properties) {
        const { shippingOptions, onCalendar } = props.cartToUpdate.properties;
        // we remove that property because it is not needed and it is causing an error
        // on the api

        if (shippingOptions && shippingOptions.length > 0) {
            delete props.cartToUpdate.properties.shippingOptions;
        }

        if (onCalendar) {
            props.cartToUpdate.properties.onCalendar = customReviewAndSubmit.onCalendar ? "Y" : "";
        }
    }

    // Most likely, we will always have a cartToUpdate, but just in case
    if (customReviewAndSubmit.cartLines) {
        customReviewAndSubmit.cartLines.forEach((cartLine: { id: string; estimateShipDate: string }) => {
            const cartLineToUpdate = props.cartToUpdate.cartLines?.find(cl => cl.id === cartLine.id);
            if (cartLineToUpdate) {
                cartLineToUpdate.properties.calendarShippingDate = cartLine.estimateShipDate;
            }
        });

        props.dispatch({
            type: "Custom/CheckoutReviewAndSubmit/ResetState",
        } as any);
    }

    const tempDeliveryDate =
        typeof requestedDeliveryDate !== "undefined"
            ? requestedDeliveryDate
            : props.cartToUpdate.requestedDeliveryDateDisplay;
    const tempPickupDate =
        typeof requestedPickupDate !== "undefined"
            ? requestedPickupDate
            : props.cartToUpdate.requestedPickupDateDisplay;

    if (customReviewAndSubmit.paymentMethod) {
        props.cartToUpdate.paymentMethod = customReviewAndSubmit.paymentMethod;
    }

    props.apiParameter = {
        cart: {
            ...props.cartToUpdate,
            requestedDeliveryDate: convertDateToApiFormat(tempDeliveryDate),
            requestedPickupDate: convertDateToApiFormat(tempPickupDate),
        },
    };
});

addToChainBefore(chain, UpdateCart, async props => {
    const splitResults = await splitOrder({
        t: Date.now().toString(),
    });

    if (splitResults) {
        // eslint-disable-next-line no-console
        console.log("Split order results: ", splitResults);
    }

    // update cartline shipping date, we only want to update the cartlines that are not quote required
    props.apiResult = await updateCartlineShippingDate({
        orderNumber: props.cartToUpdate.orderNumber,
        cartLines: props.cartToUpdate.cartLines!.filter(cl => cl.quoteRequired === false),
    });

    if (props.apiResult) {
        // eslint-disable-next-line no-console
        console.log("Update cartline shipping date results: ", props.apiResult);
    }
});
